<template>
  <div class="p-0">
    <h6 class="text-two">
      {{ question.semiology_form_question_type_description }}
    </h6>
    <textarea
      :disabled="form.status == 'FINALIZADO' || !linked_profile_id_can_answer"
      rows="2"
      class="form-control"
      v-model="question.alternatives[0].text"
      @input="input($event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: "Question",

  props: {
    linked_profile_id_can_answer: {
      type: Boolean,
      default: true,
    },

    form: Object,

    category_id: [String, Number],

    question: Object,
  },

  methods: {
    async input(text) {
      this.$emit("answer", {
        category_id: this.category_id,
        id: this.question.id,
        text,
        answer: this.question.alternatives[0].id,
      });
    },
  },
};
</script>
